import React, { memo, useEffect, useState } from "react";
import BookingApi from "../../../API/Apis/BookingApi";
import { t } from "i18next";

import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import AppStandardButton from "../../UI/AppButtons";
import TextField from "@mui/material/TextField";
import DefaultPage from "../DefaultPage";
import createTheme from "@mui/material/styles/createTheme";
import type { Theme } from "@mui/material/styles";
import { formatThemeForReservedArea } from "../../../config/MuiColorThemes";
import { AiOutlineClose, AiFillDelete } from "react-icons/ai";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Box from "@mui/material/Box";
import Pagination from "../../Layouts/ReservationsCard/Pagination";

function ReservationCard({
  reservationList,
  noOfBooking,
  handlePageChange,
  loader,
  rowsPerPage,
  page,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState<string | JSX.Element>("");
  const [messageType, setMessageType] = useState("");
  const [bookingCancelReason, setBookingCancelReason] = useState("");
  const currentLoggedInuser: string | undefined =
    localStorage.getItem("userID") || undefined;
  const [errorMessage, setErrorMessage] = useState("");
  const [, setNumber] = useState("");
  const [reservationId, setReservationId] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber] = useState("");
  //const [reservationSourceCode, setReservationSourceCode] = useState("");
  const isSmallScreen = window.innerWidth <= 768;
  const useStyles = makeStyles(() => ({
    customTableCell: {
      width: "150px",
    },
    customTableCel2: {
      width: "20px",
    },
  }));
  const [dynamicTheme, setDynamicTheme] = useState<Theme | null>(null);
  const [idSupplier, setIdSupplier] = useState("");
  useEffect(() => {
    async function fetchTheme() {
      const dynamicPalette = await formatThemeForReservedArea();
      const theme = createTheme(dynamicPalette);
      setDynamicTheme(theme);
    }
    fetchTheme();
  }, []);
  const classes = useStyles();
  const handleBookingCancelReason = (event) => {
    setBookingCancelReason(event.target.value);
  };

  const downloadInvoice = (invoiceId, idSupplier) => {
    if (invoiceId == "No Invoice Found" || invoiceId == "") {
      setModalMessage("No Invoice Found");
      setOpenModal(true);
    } else {
      // const userID: any = localStorage.getItem("userID");
      BookingApi.downloadInvoice(invoiceId, idSupplier).then((e) => {
        if (e.data.status == "error") {
          setModalMessage(e.data.errorMessage);
          setOpenModal(true);
        } else {
          const url = e.data;
          window.open(url, "_blank");
        }
      });
    }
  };

  // Api for sendRequest.
  const sendRequest = (reservationId, name, description, email, number) => {
    setReservationId(reservationId);
    setName(name);
    setDescription(description);
    setEmail(email);
    setNumber(number);
    setModalMessage(
      <span
        style={{
          fontFamily: "MBCorpoSText-Regular-Web-new",
          fontSize: "24px",
          fontWeight: "500",
          lineHeight: "31.97px",
        }}
      >
        {t("Cancel request")}
      </span>
    );
    setMessageType("CancelBooking");
    setOpenModal(true);
  };

  const [expandedCardIndex, setExpandedCardIndex] = useState<number | null>(
    null
  );
  const handleExpandClick = (index: number) => {
    setExpandedCardIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  // const userId: any = localStorage.getItem("userID");
  const [cancelledReservations, setCancelledReservations] = useState(() => {
    try {
      const stored = localStorage.getItem("cancelledReservations");
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });
  const requestBookingCancel = () => {
    if (bookingCancelReason == "") {
      setErrorMessage("** Reason is mandatory **");
    } else {
      setMessageType("");
      setModalMessage("");
      setOpenModal(false);
      BookingApi.sendRequest(
        reservationId,
        name,
        description,
        contactNumber,
        email,
        bookingCancelReason,
        currentLoggedInuser,
        idSupplier || ""
      )
        .then(() => {
          setCancelledReservations((prev) => {
            const updated = [...prev, reservationId];
            localStorage.setItem(
              "cancelledReservations",
              JSON.stringify(updated)
            );
            return updated;
          });
          setModalMessage(t("Your cancellation request send Sucessfully."));
          setOpenModal(true);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const onRequestClose = () => {
    setMessageType("");
    setModalMessage("");
    setErrorMessage("");
    setOpenModal(false);
    setBookingCancelReason("");
  };

  return (
    <>
      <Dialog
        open={openModal}
        onClose={onRequestClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { borderRadius: "20px" } }}
      >
        <DialogTitle>{modalMessage}</DialogTitle>

        <DialogActions>
          <Grid container item xs={12}>
            {messageType == "CancelBooking" && (
              <Grid item xs={12}>
                <TextField
                  id="outlined-multiline-flexible"
                  multiline
                  rows={5}
                  variant="outlined"
                  fullWidth
                  style={{
                    padding: "1rem",
                    fontFamily: "MBCorpoSText-Regular-Web-new",
                    fontSize: "24px",
                    fontWeight: "500px",
                    marginTop: "-5%",
                    lineHeight: "31.97px",
                  }}
                  onChange={handleBookingCancelReason}
                  value={bookingCancelReason}
                />
                <span
                  style={{
                    textAlign: "center",
                    color: "red",
                    display: "block",
                    fontStyle: "italic",
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  }}
                >
                  {errorMessage}
                </span>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container justifyContent="center">
                {messageType == "CancelBooking" && (
                  <Grid item style={{ marginRight: "15px" }}>
                    <AppStandardButton
                      variant="contained"
                      onClick={requestBookingCancel}
                      style={{ backgroundColor: "primary" }}
                    >
                      <p className="text-light normal-case">
                        {t("Cancel Booking")}
                      </p>
                    </AppStandardButton>
                  </Grid>
                )}
                <Grid item>
                  <AppStandardButton
                    variant="outlined"
                    onClick={onRequestClose}
                  >
                    <p className="text-black normal-case"> {t("Close")}</p>
                  </AppStandardButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {!isSmallScreen &&
        (loader ? (
          <RenderLoading />
        ) : (
          <div className="w-[100%] rounded-sm">
            {!reservationList || reservationList.length === 0 ? (
              <RenderNoBookingMessage t={t} />
            ) : (
              <>
                <BookingTable
                  reservationList={reservationList}
                  classes={classes}
                  t={t}
                  dynamicTheme={dynamicTheme}
                  setIdSupplier={setIdSupplier}
                  sendRequest={sendRequest}
                  cancelledReservations={cancelledReservations}
                />
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Pagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    count={noOfBooking}
                    onPageChange={handlePageChange}
                  />
                </div>
              </>
            )}
          </div>
        ))}

      {isSmallScreen &&
        (loader ? (
          <RenderLoading />
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {!reservationList || reservationList.length === 0 ? (
              <RenderNoBookingMessage />
            ) : (
              <>
                <BookingGridTable
                  handlePageChange={handlePageChange}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  noOfBooking={noOfBooking}
                  sendRequest={sendRequest}
                  reservationList={reservationList}
                  expandedCardIndex={expandedCardIndex}
                  handleExpandClick={handleExpandClick}
                  downloadInvoice={downloadInvoice}
                  t={t}
                />
              </>
            )}
          </div>
        ))}
    </>
  );
}

function BookingTable({
  reservationList,
  classes,
  t,
  dynamicTheme,
  setIdSupplier,
  sendRequest,
  cancelledReservations,
}) {
  return (
    <>
      <TableContainer>
        <Table
          className="!border-2 rounded-2xl"
          aria-label="simple table"
          stickyHeader
        >
          <TableHead
            className="!bg-gray-500"
            style={{
              fontFamily: "MBCorpoSText-CondLight-Web",
              backgroundColor: "#BDBDBD",
            }}
          >
            <TableRow className="rounded-2xl">
              <TableCell
                className={`!text-[14px] rounded-tl-2xl ${classes.customTableCell}`}
                style={{
                  backgroundColor: "#BDBDBD", // Gray color for table header
                  color: "#000000",
                }}
              >
                {t("Reservation")}
              </TableCell>
              <TableCell
                className={`!text-[14px] ${classes.customTableCell}`}
                style={{
                  backgroundColor: "#BDBDBD",
                  color: "#000000",
                }}
              >
                {t("Customer")}
              </TableCell>
              <TableCell
                className={`!text-[14px] ${classes.customTableCell}`}
                style={{
                  backgroundColor: "#BDBDBD",
                  color: "#000000",
                }}
              >
                {t("Pick up location")}
              </TableCell>
              <TableCell
                className={`!text-[14px] ${classes.customTableCell}`}
                style={{
                  backgroundColor: "#BDBDBD",
                  color: "#000000",
                }}
              >
                {t("Drop off location")}
              </TableCell>
              <TableCell
                className={`!text-[14px] ${classes.customTableCell}`}
                style={{
                  backgroundColor: "#BDBDBD",
                  color: "#000000",
                }}
              >
                {t("Date")}
              </TableCell>
              <TableCell
                className={`!text-[14px] ${classes.customTableCell}`}
                style={{
                  backgroundColor: "#BDBDBD",
                  color: "#000000",
                }}
              >
                {t("Group")}
              </TableCell>
              <TableCell
                className={`!text-[14px] ${classes.customTableCell}`}
                style={{
                  backgroundColor: "#BDBDBD",
                  color: "#000000",
                }}
              >
                {t("Total Amount")}
              </TableCell>
              <TableCell
                className={`!text-[14px] rounded-tr-2xl ${classes.customTableCel2}`}
                style={{
                  backgroundColor: "#BDBDBD",
                  color: "#000000",
                }}
              >
                {t("Action")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reservationList?.map((e: any, i) => (
              <TableRow key={i}>
                <TableCell
                  className="!text-[12px] text-[#333]"
                  component="th"
                  scope="e"
                >
                  <ul>
                    <li className="text-[#838181] text-[10px]">
                      {`${e.prefix}${e.number}`}
                    </li>
                  </ul>
                </TableCell>
                <TableCell
                  className="!text-[12px] text-[#333]"
                  component="th"
                  scope="e"
                >
                  <ul>
                    <li className="!text-[#333]">
                      {e.clientiByIdCliente.description
                        .split("/")[0]
                        .split("-")
                        .reverse()
                        .join(" ") || ""}
                    </li>
                    <li className="text-[#838181] text-[10px]">
                      {e.clientiByIdCliente.email || ""}
                    </li>
                  </ul>
                </TableCell>
                <TableCell className="!text-[12px]">
                  <ul>
                    <li>{e.locationPickupExcepted || ""}</li>
                    <li className="text-[#838181] text-[10px]">
                      {e.startDate.slice(11, 19) || ""}
                    </li>
                  </ul>
                </TableCell>
                <TableCell className="!text-[12px]">
                  <ul>
                    <li>{e.locationReturnExcepted || ""}</li>
                    <li className="text-[#838181] text-[10px]">
                      {e.endDate.slice(11, 19) || ""}
                    </li>
                  </ul>
                </TableCell>
                <TableCell className="!text-[12px]">
                  {`${String(new Date(e.startDate).getDate()).padStart(
                    2,
                    "0"
                  )}-${String(new Date(e.startDate).getMonth() + 1).padStart(
                    2,
                    "0"
                  )}-${new Date(e.startDate).getFullYear()}`}{" "}
                  -{" "}
                  {`${String(new Date(e.endDate).getDate()).padStart(
                    2,
                    "0"
                  )}-${String(new Date(e.endDate).getMonth() + 1).padStart(
                    2,
                    "0"
                  )}-${new Date(e.endDate).getFullYear()}`}
                </TableCell>
                <TableCell className="!text-[12px]">
                  {e.assignedGroup || ""}
                </TableCell>
                <TableCell className="!text-[12px]">
                  {"€" + " " + e.totalRental || ""}
                </TableCell>
                <TableCell className="!text-[12px]">
                  <button
                    disabled={
                      e.isCancel === true ||
                      cancelledReservations.includes(e.id)
                    }
                    className={`flex text-[12px] p-2 gap-2 h-30 rounded shadow`}
                    style={
                      e.isCancel === true ||
                      cancelledReservations.includes(e.id)
                        ? {
                            backgroundColor: "#F0F0F0",
                            color: "#D7D7D7",
                          }
                        : {
                            backgroundColor:
                              dynamicTheme?.palette?.["secondaryColor"]?.main,
                            color:
                              dynamicTheme?.palette?.["secondaryColor"]
                                ?.contrastText,
                          }
                    }
                    onClick={() => {
                      setIdSupplier(e.idSupplier);
                      sendRequest(
                        e.id,
                        e.clientiByIdCliente.description
                          .split("/")[0]
                          .split("-")
                          .reverse()
                          .join(" ") || "",
                        e.assignedGroup || "",
                        e.clientiByIdCliente?.mobileNumber,
                        e.clientiByIdCliente?.email,
                        e.idSupplier || ""
                      );
                    }}
                  >
                    {t("Richiedi Annullamento")}
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

function RenderLoading() {
  return (
    <Typography
      className="!text-center !text-3xl flex justify-center"
      style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
    >
      Loading...
    </Typography>
  );
}

function BookingGridTable({
  reservationList,
  handleExpandClick,
  expandedCardIndex,
  handlePageChange,
  rowsPerPage,
  page,
  noOfBooking,
  sendRequest,
  downloadInvoice,
  t,
}) {
  return (
    <Grid container spacing={2}>
      {reservationList?.map((e: any, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card
            className="!shadow-2xl rounded-2xl !border-solid !border-2 !border-grey-400 w-full whitespace-nowrap"
            style={{
              borderRadius: "8px",
            }}
          >
            <CardHeader
              title={`${e.prefix || ""} ${e.number || ""}`}
              action={
                <button
                  className={"float-right"}
                  style={{
                    fontFamily: "MBCorpoATextCond-Regular-Web",
                    color: "#000000",
                  }}
                  onClick={() => handleExpandClick(i)}
                >
                  {/* Conditionally render edit image or cross icon */}
                  {expandedCardIndex === i ? (
                    <AiOutlineClose
                      className="h-fit cursor-pointer h-[22px]"
                      aria-label="Close"
                    />
                  ) : (
                    <img
                      className="cursor-pointer h-[22px] filter grayscale contrast-100"
                      src="/assets/images/editImage.png"
                      alt="Edit"
                    />
                  )}
                </button>
              }
              style={{
                color: "#000000",
                backgroundColor: "#BDBDBD",
                fontFamily: "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                height: "40px",
                lineHeight: "1.5",
              }}
              titleTypographyProps={{
                style: {
                  color: "#000000",
                  fontSize: "14px",
                },
              }}
            />
            <CardContent
              style={{
                padding: "8px 16px",
              }}
            >
              {expandedCardIndex === i ? (
                // Detailed view (expanded card content)
                <div>
                  {/* Customer Details */}
                  <Typography
                    style={{
                      fontSize: "18px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    {t("Customer Details")}
                  </Typography>
                  <Box
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "2px",
                      padding: "16px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Full name")}</span>
                      <span>
                        {e.clientiByIdCliente.description
                          .split("/")[0]
                          .split("-")
                          .reverse()
                          .join(" ") || ""}
                      </span>
                    </Typography>
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Email")}</span>
                      <span style={{ color: "#7B7B7B" }}>
                        {e.clientiByIdCliente.email || ""}
                      </span>
                    </Typography>
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Phone Number")}</span>
                      <span style={{ color: "#7B7B7B" }}>
                        {e.clientiByIdCliente.mobileNumber || ""}
                      </span>
                    </Typography>
                  </Box>

                  {/* Reservation Details */}
                  <Typography
                    style={{
                      fontSize: "18px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    {t("Reservation Details")}
                  </Typography>
                  <Box
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "2px",
                      padding: "16px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Pick up location")}</span>
                      <span> {e.locationPickupExcepted || ""}</span>
                    </Typography>
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Drop off location")}</span>
                      <span>{e.locationReturnExcepted || ""}</span>
                    </Typography>
                    <div style={{ height: "16px" }} />

                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Pick Up Date")}</span>
                      <span style={{ color: "#7B7B7B" }}>
                        {`${String(new Date(e.startDate).getDate()).padStart(
                          2,
                          "0"
                        )}-${String(
                          new Date(e.startDate).getMonth() + 1
                        ).padStart(2, "0")}-${new Date(
                          e.startDate
                        ).getFullYear()}`}
                      </span>
                    </Typography>

                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("pick up time")}</span>
                      <span style={{ color: "#7B7B7B" }}>
                        {`${e.startDate.slice(11, 19) || ""}`}
                      </span>
                    </Typography>
                    <div style={{ height: "16px" }} />

                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Drop Off Date")}</span>
                      <span style={{ color: "#7B7B7B" }}>
                        {`${String(new Date(e.endDate).getDate()).padStart(
                          2,
                          "0"
                        )}-${String(
                          new Date(e.endDate).getMonth() + 1
                        ).padStart(2, "0")}-${new Date(
                          e.endDate
                        ).getFullYear()}`}
                      </span>
                    </Typography>

                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("drop off time")}</span>
                      <span style={{ color: "#7B7B7B" }}>
                        {`${e.endDate.slice(11, 19) || ""}`}
                      </span>
                    </Typography>
                  </Box>

                  {/* Vehicle Details */}
                  <Typography
                    style={{
                      fontSize: "18px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    {t("Vehicle Details")}
                  </Typography>
                  <Box
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "2px",
                      padding: "16px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Group")}</span>
                      <span>{e.assignedGroup || ""}</span>
                    </Typography>
                    <Typography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <span>{t("Vehicle")}</span>
                      <span style={{ color: "#7B7B7B" }}>
                        {e.vehicle || ""}
                      </span>
                    </Typography>
                  </Box>

                  {/* Download Invoice */}
                  <Typography
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    <span>{t("Download the Invoice")}</span>
                    <span>
                      <button
                        className="flex items-center text-[14px] h-70 text-[#000000] rounded border border-[#000000] bg-white p-1" // Add border and background
                        style={{
                          height: "19px",
                        }}
                        onClick={() =>
                          downloadInvoice(e.invoices, e.idSupplier)
                        }
                      >
                        {t("Invoice")}
                        <img
                          className="h-3"
                          style={{ marginLeft: "5px" }}
                          src="/assets/images/downloadIcon.png"
                          alt="Invoice Icon"
                        />
                      </button>
                    </span>
                  </Typography>
                  <Typography
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      marginTop: "7px",
                    }}
                  >
                    <span>{t("Want to delete your reservation?")}</span>
                    <span>
                      <button
                        className="flex items-center text-[14px] h-70 text-[#FF0000] rounded border border-[#FF0000] bg-white p-1" // Add border and background
                        style={{
                          height: "19px",
                        }}
                        onClick={() =>
                          sendRequest(
                            e.id,
                            e.clientiByIdCliente.description
                              .split("/")[0]
                              .split("-")
                              .reverse()
                              .join(" ") || "",
                            e.assignedGroup || "",
                            e.clientiByIdCliente?.mobileNumber,
                            e.clientiByIdCliente?.email,
                            e.idSupplier || ""
                          )
                        }
                      >
                        <span style={{ marginLeft: "5px" }}>{t("Delete")}</span>
                        <AiFillDelete className="h-4 w-4" />
                      </button>
                    </span>
                  </Typography>
                </div>
              ) : (
                // Compact view (initial card content)
                <>
                  <Typography
                    className="!text-[15px]"
                    gutterBottom
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    <span>{t("Customer")}</span>
                    <span>
                      {e.clientiByIdCliente.description
                        .split("/")[0]
                        .split("-")
                        .reverse()
                        .join(" ") || ""}
                    </span>
                  </Typography>
                  <hr />
                  <Typography
                    className="!text-[15px]"
                    gutterBottom
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    <span> {t("Pick up location")}</span>
                    <span>{e.locationPickupExcepted || ""}</span>
                  </Typography>
                  <hr />

                  <Typography
                    className="!text-[15px]"
                    gutterBottom
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    <span> {t("Drop off location")}</span>
                    <span>{e.locationReturnExcepted || ""}</span>
                  </Typography>
                  <hr />
                  <Typography
                    className="!text-[15px]"
                    gutterBottom
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    <span> {t("Date")}</span>
                    <span>
                      {" "}
                      {`${String(new Date(e.startDate).getDate()).padStart(
                        2,
                        "0"
                      )}-${String(
                        new Date(e.startDate).getMonth() + 1
                      ).padStart(2, "0")}-${new Date(
                        e.startDate
                      ).getFullYear()}`}{" "}
                      -{" "}
                      {`${String(new Date(e.endDate).getDate()).padStart(
                        2,
                        "0"
                      )}-${String(new Date(e.endDate).getMonth() + 1).padStart(
                        2,
                        "0"
                      )}-${new Date(e.endDate).getFullYear()}`}
                    </span>
                  </Typography>
                  <hr />

                  <Typography
                    className="!text-[15px]"
                    gutterBottom
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                    }}
                  >
                    <span>{t("Vehicle Details")}</span>
                    <span
                      style={{
                        marginTop: "3px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "12px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      {e.vehicle || ""}
                    </span>
                  </Typography>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
      <div
        style={{
          display: "flex",
          marginLeft: noOfBooking > 5 ? "20%" : "25%",
        }}
        className="mt-[15px]"
      >
        <Pagination
          count={noOfBooking}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
        />
      </div>
    </Grid>
  );
}

function RenderNoBookingMessage() {
  return (
    <DefaultPage
      message={t(
        "You have not created any booking yet. To create a new booking, please click on the Book a car button."
      )}
    />
  );
}
export default memo(ReservationCard);
